import { ErrorCodes, SuccessStatusCode } from "../../src/util/UIConstants";

export class APIMiddleware {
  public static getMappedHTTPStatusCode = (statusCode: any) => {
    switch (statusCode) {
      case ErrorCodes.ApiValidationErrorBadRequest:
        return ErrorCodes.ApiValidationErrorBadRequest;
      case ErrorCodes.ApiValidationErrorPreConditionFailed:
        return ErrorCodes.ApiValidationErrorPreConditionFailed;
      case ErrorCodes.ApiResourceNotFound:
        return ErrorCodes.ApiResourceNotFound;
      case ErrorCodes.ApiValidationFailedUnauthorize:
        return ErrorCodes.ApiValidationFailedUnauthorize;
    }

    if (!SuccessStatusCode.includes(statusCode)) {
      return ErrorCodes.ApiFailedWithNoSuccess;
    }

    return ErrorCodes.NoError;
  };

  public static async fetch(method: string, url: string, token: string, body: any): Promise<any> {
    let apiResponse = {
      data: undefined,
      apiResponseReturned: false,
      error: undefined,
      ok: false,
      status: undefined,
      errorCode: ErrorCodes.NoError,
      statusText: "",
    };
    let contentType = "application/json; charset=UTF-8"; // Indicates the content
    try {
      await fetch(url, {
        method: method,
        headers: {
          Authorization: "Bearer " + token,
          "Content-type": method == "PATCH" ? "application/json-patch+json; charset=utf-8" : contentType, // Indicates the content
        },
        body: body,
      })
        .then(async (response) => {
          apiResponse.ok = response.ok;
          apiResponse.status = response.status;

          apiResponse.errorCode = this.getMappedHTTPStatusCode(response.status);
          apiResponse.apiResponseReturned = true;
          apiResponse.statusText = response.statusText;
          if (response.status != 204) {
            apiResponse.data = await response.json();
          } else {
            apiResponse.data = [];
          }

          // const data = (await response.json()) + "response returned " + url;
          console.log("response returned" + response);
        })
        .catch((error) => {
          // api server did not hit
          apiResponse.error = error;
          const data = error + "response returned with error, api server did not hit" + url;
          console.log(data);
          apiResponse.errorCode = ErrorCodes.HerculesApiNoResponseError;
        })
        .finally(() => {});
    } catch (error) {
      apiResponse.errorCode = ErrorCodes.HerculesApiNoResponseError;
      apiResponse = error;
      const data = error + "response returned with error, error at UI layer " + url;
      console.log(data);
    }
    return apiResponse;
  }
}
